import React from 'react';
import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';
import { RenderRetailTableActionButtons } from '../../commons/tableActionButton/tableActionButton';
import {
  trackCN,
  getRetailTableCellObject,
  getFormattedDateAndTime,
  getFormattedDate,
  getFormattedTime,
  getTimeinHoursWithMinutes,
  clientPriorityObject,
  convertMsToAmPm
} from '../../../services/helpers';
import {
  getSmallDeliveryTypeTag,
  isStatusPending,
  isAppointmentDelivery,
  isClientAmazon
} from '../../helper/DeliveryTypeHelper';

const clockLogo = require('../../../assets/images/clock.svg');
const notRequiredLogo = require('../../../assets/images/not-required.svg');

export const areAllRowsSelected = rows => {
  let isAllSelected = true;
  rows.forEach(r => {
    if (!r.isSelected && (!r._original || !r._original.isSelected)) {
      isAllSelected = false;
    }
  });
  return isAllSelected;
};

export const tabViewList = [
  {
    key: 'APPOINTMENT',
    name: 'Appointment'
  },
  {
    key: 'MALL',
    name: 'Mall'
  },
  {
    key: 'CANTEEN',
    name: 'Canteen'
  },
  {
    key: 'NORMAL',
    name: 'Normal'
  },
  {
    key: 'HOLIDAY_DELIVERY',
    name: 'Holiday Delivery'
  },
  {
    key: 'PLANT',
    name: 'Plant'
  },
  {
    key: 'GOVERNMENT_COMPOUND',
    name: 'Government Compound'
  }
];

const getFormattedTimeSlot = (startTime, endTime) => {
  const start = startTime ? convertMsToAmPm(startTime) : null;
  const end = endTime ? convertMsToAmPm(endTime) : null;

  let str = '';

  if (start && end) {
    str = start + ' - ' + end;
  } else if (!start && end) {
    str = end;
  } else if (start && !end) {
    str = start;
  } else {
    str = '--';
  }
  return (
    <>
      <div style={{ wordBreak: 'break-word' }}>{str}</div>
    </>
  );
};

function getDisplayElementForPOdetails(consignmentId) {
  return (
    <div
      className="cn-highlight"
      onClick={() =>
        zoomTableActionsConfig.CE_TASKBOARD.actions &&
        zoomTableActionsConfig.CE_TASKBOARD.actions.getPoDetailsAndOpenModal(
          consignmentId
        )
      }
    >
      PO details
    </div>
  );
}

export const ceTaskboardHolidayDeliveryConfig = {
  columns: [
    {
      Header: 'Cno.',
      headerClassName: 'zt-custom-th flex-16',
      sortable: false,
      className: 'zt-custom-td flex-16',
      Cell: row => (
        <div onClick={() => trackCN(row.original)}>
          <div className="l-row a-center">
            {getRetailTableCellObject(
              row.original.cnote,
              '',
              '',
              '',
              'cn-highlight'
            )}
          </div>
          <div className="l-row">
            {getSmallDeliveryTypeTag(
              row.original.appointmentStatus,
              row.original.deliveryType
            )}
            {row.original.consignmentPriorityDecision ===
              clientPriorityObject.priority && (
              <div
                className="cnote-tag small priority"
                title={clientPriorityObject.text}
              >
                {clientPriorityObject.label}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      Header: 'Request by',
      headerClassName: 'zt-custom-th flex-14',
      className: 'zt-custom-td flex-14',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(
          row.original.requestUserName,
          row.original.mobileNumber
        )
    },
    {
      Header: 'Current External CPD',
      headerClassName: 'flex-14 zt-custom-th',
      className: 'zt-custom-td flex-14',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(
          getFormattedDate(row.original.currentExternalCpd)
        )
    },
    {
      Header: 'Internal CPD',
      headerClassName: 'flex-14 zt-custom-th',
      className: 'zt-custom-td flex-14',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(getFormattedDate(row.original.internalCpd))
    },
    {
      Header: 'Requested CPD',
      headerClassName: 'flex-14 zt-custom-th',
      className: 'zt-custom-td flex-14',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(getFormattedDate(row.original.requestedCpd))
    },
    {
      Header: 'Request Date',
      headerClassName: 'flex-14 zt-custom-th',
      className: 'zt-custom-td flex-14',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(getFormattedDate(row.original.requestedDate))
    },
    {
      Header: 'Action',
      headerClassName: 'flex-24 zt-custom-th',
      className: 'flex-24',
      sortable: false,
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.CE_TASKBOARD_HOLIDAY.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No tasks found',
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const ceTaskboardConfig = {
  columns: [
    {
      Header: row => {
        return (
          <input
            type="checkbox"
            checked={areAllRowsSelected(row.data)}
            onClick={() => {
              if (
                zoomTableActionsConfig.CE_TASKBOARD.actions &&
                zoomTableActionsConfig.CE_TASKBOARD.actions.onAllRowSelect
              ) {
                zoomTableActionsConfig.CE_TASKBOARD.actions.onAllRowSelect();
              }
            }}
          />
        );
      },
      headerClassName: 'zt-custom-th flex-5',
      sortable: false,
      className: 'zt-custom-td flex-5',
      Cell: (row, a) => {
        return (
          <div>
            <input
              type="checkbox"
              checked={row.original && row.original.isSelected}
              onClick={() => {
                if (
                  zoomTableActionsConfig.CE_TASKBOARD.actions &&
                  zoomTableActionsConfig.CE_TASKBOARD.actions.onRowSelect
                ) {
                  zoomTableActionsConfig.CE_TASKBOARD.actions.onRowSelect(
                    row && row.original
                  );
                }
              }}
            ></input>
          </div>
        );
      }
    },
    {
      Header: 'Cno.',
      headerClassName: 'zt-custom-th flex-9',
      sortable: false,
      className: 'zt-custom-td flex-9',
      Cell: row => (
        <div onClick={() => trackCN(row.original)}>
          <div className="l-row a-center">
            {getRetailTableCellObject(
              row.original.cnote,
              '',
              '',
              '',
              'cn-highlight'
            )}
          </div>
          <div className="l-row">
            {getSmallDeliveryTypeTag(
              row.original.appointmentStatus,
              row.original.deliveryType
            )}
            {row.original.consignmentPriorityDecision ===
              clientPriorityObject.priority && (
              <div
                className="cnote-tag small priority"
                title={clientPriorityObject.text}
              >
                {clientPriorityObject.label}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      Header: 'Client',
      headerClassName: 'zt-custom-th flex-7',
      className: 'zt-custom-td flex-7',
      sortable: false,
      Cell: row => getRetailTableCellObject(row.original.clientCode)
    },
    {
      Header: () => (
        <div>
          <div>Consignee Name</div>
          <div>and Address</div>
        </div>
      ),
      headerClassName: 'flex-17 zt-custom-th',
      className: 'zt-custom-td flex-17',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(
          row.original.consigneeName,
          row.original.consigneeAddress
        )
    },
    {
      Header: 'From',
      headerClassName: 'flex-5 zt-custom-th',
      className: 'zt-custom-td flex-5',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(row.original.fromHub, row.original.fromHubName)
    },
    {
      Header: 'To',
      headerClassName: 'flex-5 zt-custom-th',
      className: 'zt-custom-td flex-5',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(row.original.toHub, row.original.toHubName)
    },
    {
      Header: () => (
        <div>
          <div>Booking Date</div>
          <div>and Time</div>
        </div>
      ),
      headerClassName: 'flex-7 zt-custom-th',
      className: 'zt-custom-td flex-7',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(
          getFormattedDate(row.original.bookingDateTime),
          getFormattedTime(row.original.bookingDateTime)
        )
    },
    {
      Header: 'CPD',
      headerClassName: 'flex-7 zt-custom-th',
      className: 'zt-custom-td flex-7',
      sortable: false,
      Cell: row =>
        getRetailTableCellObject(
          getFormattedDate(row.original.promisedDeliveryDateTime),
          getFormattedTime(row.original.promisedDeliveryDateTime)
        )
    },
    {
      Header: () => (
        <div>
          <div>Appointment ID /</div>
          <div>PO Number</div>
        </div>
      ),
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      Cell: row => {
        if (isAppointmentDelivery(row.original.deliveryType)) {
          return (
            <div className="l-col">
              <div className="l-row text-wrap-ellipsis" title="To be scheduled">
                <img src={clockLogo} alt="To be scheduled" />
                <div
                  className="text-wrap-ellipsis"
                  style={{ marginLeft: '5px' }}
                >
                  To be scheduled
                </div>
              </div>
              {isClientAmazon(row.original.deliveryClient)
                ? getDisplayElementForPOdetails(row.original.id)
                : null}
            </div>
          );
        }
        return (
          <div className="l-row text-wrap-ellipsis" title="Not required">
            <img src={notRequiredLogo} alt="Not required" />
            <div className="text-wrap-ellipsis" style={{ marginLeft: '5px' }}>
              Not required
            </div>
            {isClientAmazon(row.original.deliveryClient)
              ? getDisplayElementForPOdetails(row.original.id)
              : null}
          </div>
        );
      }
    },
    {
      Header: 'Delivery Client',
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      Cell: row => getRetailTableCellObject(row.original.deliveryClient, '')
    },
    {
      Header: () => (
        <div>
          <div>Appointment</div>
          <div>Time & Slot</div>
        </div>
      ),
      headerClassName: 'flex-9 zt-custom-th',
      className: 'zt-custom-td flex-9',
      sortable: false,
      Cell: row => {
        if (row.original.appointmentTime) {
          return getRetailTableCellObject(
            getFormattedDate(row.original.appointmentTime),
            row.original.appointmentStartTime
              ? getFormattedTimeSlot(
                  row.original.appointmentStartTime,
                  row.original.appointmentTime
                )
              : getFormattedTime(row.original.appointmentTime)
          );
        }
        if (isAppointmentDelivery(row.original.deliveryType)) {
          return (
            <div className="l-row text-wrap-ellipsis" title="To be scheduled">
              <img src={clockLogo} alt="To be scheduled" />
              <div className="text-wrap-ellipsis" style={{ marginLeft: '5px' }}>
                To be scheduled
              </div>
            </div>
          );
        }
        return (
          <div className="l-row text-wrap-ellipsis" title="Not required">
            <img src={notRequiredLogo} alt="Not required" />
            <div className="text-wrap-ellipsis" style={{ marginLeft: '5px' }}>
              Not required
            </div>
          </div>
        );
      }
    },
    {
      Header: 'Task Status',
      headerClassName: 'flex-10 zt-custom-th',
      className: 'zt-custom-td flex-10',
      sortable: false,
      Cell: row => {
        if (isStatusPending(row.original.appointmentStatus)) {
          return getRetailTableCellObject(
            'Pending since',
            getTimeinHoursWithMinutes(
              Date.now() - row.original.appointmentCreationTime
            )
          );
        }
        return <div>{row.original.appointmentStatus}</div>;
      }
    },
    {
      Header: 'Action',
      headerClassName: 'flex-12 zt-custom-th',
      className: 'flex-12',
      sortable: false,
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.CE_TASKBOARD.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No tasks found',
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const ceTaskboardHolidayDeliveryTableActionConfig = {
  buttons: [
    {
      label: 'Approve',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions.approveHolidayDelivery
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.approveHolidayDelivery(
            rowData
          );
        }
      },
      disabledFn: rowData => {
        if (
          rowData.cnote ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    },
    {
      label: 'Reject',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions
            .openRejectHolidayDeliveryModal
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.openRejectHolidayDeliveryModal(
            rowData
          );
        }
      },
      disabledFn: rowData => {
        if (
          rowData.cnote ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    }
  ]
};

export const ceTaskboardTableActionConfig = {
  buttons: [
    {
      label: 'Approve',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions.approveTask
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.approveTask(rowData);
        }
      },
      hide: rowData => rowData && !isStatusPending(rowData.appointmentStatus),
      disabledFn: rowData => {
        if (
          rowData.id ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    },
    {
      label: 'Reject',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions.rejectTask
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.rejectTask(rowData);
        }
      },
      hide: rowData => rowData && !isStatusPending(rowData.appointmentStatus),
      disabledFn: rowData => {
        if (
          rowData.id ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    },
    {
      label: 'Edit',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions.openScheduleModal
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.openScheduleModal(
            rowData,
            'edit'
          );
        }
      },
      hide: rowData => rowData && !isStatusPending(rowData.appointmentStatus),
      disabledFn: rowData => {
        if (
          rowData.id ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    },
    {
      label: rowData =>
        rowData.appointmentTime && rowData.appointmentId
          ? 'Re-Schedule'
          : 'Schedule',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions.openScheduleModal
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.openScheduleModal(
            rowData,
            null
          );
        }
      },
      hide: rowData =>
        rowData &&
        (!isAppointmentDelivery(rowData.deliveryType) ||
          isStatusPending(rowData.appointmentStatus)),
      disabledFn: rowData => {
        if (
          rowData.id ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    },
    {
      label: rowData =>
        rowData.isConsignmentDacc ? 'Unmark DACC CN' : 'Mark DACC CN',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.CE_TASKBOARD.actions &&
          zoomTableActionsConfig.CE_TASKBOARD.actions.openDaccModal
        ) {
          zoomTableActionsConfig.CE_TASKBOARD.actions.openDaccModal(rowData);
        }
      },
      hide: rowData => rowData && !rowData.isClientDacc,
      disabledFn: rowData => {
        if (
          rowData.id ===
          zoomTableActionsConfig.CE_TASKBOARD.actions.disableRowButtons()
        ) {
          return true;
        } else {
          return false;
        }
      },
      actionButtonRetailWrapper: {}
    }
  ]
};

export const poDetailsConfig = {
  columns: [
    {
      Header: 'PO No.',
      headerClassName: 'zt-custom-th flex-50 j-center',
      sortable: false,
      className: 'zt-custom-td flex-50 j-center',
      Cell: row => (
        <div className="zt-custom-td flex-50 j-center">{row.original.po}</div>
      )
    },
    {
      Header: 'No. Of Units',
      headerClassName: 'zt-custom-th flex-50 j-center',
      className: 'zt-custom-td flex-50 j-center',
      sortable: false,
      Cell: row => (
        <div className="zt-custom-td flex-50 j-center">
          {row.original.units}
        </div>
      )
    },
    {
      Header: 'Expiry Date',
      headerClassName: 'zt-custom-th flex-50 j-center',
      className: 'zt-custom-td flex-50 j-center',
      sortable: false,
      Cell: row => (
        <div className="zt-custom-td flex-50 j-center">
          {row.original.poExpiryTime
            ? getFormattedDateAndTime(row.original.poExpiryTime)
            : '--'}
        </div>
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No Po Details Found',
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const bulkActionsDropdown = [
  { key: 'Approve', val: 'Approve' },
  { key: 'Reject', val: 'Reject' }
];
